import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { withStyles } from "@material-ui/core/styles";

import StarBorderIcon from "@material-ui/icons/StarBorderOutlined";
import StarIcon from "@material-ui/icons/Star";
import ThumbsUpDownIcon from "@material-ui/icons/ThumbsUpDown";
import Rating from "@material-ui/lab/Rating";

import Button from "../../components/Button";
import Card from "../../components/Card/Card.js";
import CardBody from "../../components/Card/CardBody.js";
import CardHeader from "../../components/Card/CardHeader.js";

import CardIcon from "../../components/Card/CardIcon.js";
import CustomInput from "../../components/CustomInput/CustomInput.js";
import GridContainer from "../../components/Grid/GridContainer.js";
import GridItem from "../../components/Grid/GridItem.js";
import Snackbar from "../../components/Snackbar/Snackbar.js";
import { rateAppointment } from "../../services/appointments";
//import styles from "@vendors/CreativeTim/assets/jss/material-dashboard-pro-react/views/dashboardStyle.js";
import styles from "@vendors/CreativeTim/assets/jss/material-dashboard-pro-react/views/userProfileStyles.js";
const useStyles = makeStyles(styles);
const StyledRating = withStyles({
  iconFilled: {
    color: "#5cb860",
    fontSize: "large",
  },
  iconHover: {
    color: "#5cb860",
    fontSize: "large",
  },
})(Rating);

const RequesterRating = (props) => {
  const { authKey, onClose } = props;
  const appointmentNum = props.appointmentInfo.appointmentTypeYearNumber;
  const classes = useStyles();
  const [comment, setComment] = useState("");
  const [interpretingRating, setInterpretingRating] = useState(0);
  const [avRating, setAvRating] = useState(0);
  const [successUpdate, setSuccessUpdate] = useState(false);
  const [failUpdate, setFailUpdate] = useState(false);

  const handleInterpretingRatingChange = (event, value) => {
    console.log("EVENT" + { event });
    console.log("NEW VALUE: " + value);
    setInterpretingRating(value);
  };
  const handleAvQualityRatingChange = (event, value) => {
    console.log("EVENT" + { event });
    console.log("NEW VALUE: " + value);
    setAvRating(value);
  };

  const handleCommentsChange = (event) => {
    console.log("submitted");
    setComment(event.target.value);
  };
  const handleRatingsSubmit = (event) => {
    event.preventDefault();
    const ratings = {
      techRating: avRating,
      comment: comment,
      intRating: interpretingRating,
    };
    // console.log("submitted" + JSON.stringify(ratings));
    // console.log("appointment" + appointmentNum);
    rateAppointment(appointmentNum, ratings, authKey).then((response) => {
      if (response.status === 200) {
        setSuccessUpdate(true);
        setTimeout(onClose, 2000);
      } else {
        console.log("FAIL");
        setFailUpdate(true);
      }
    });
  };
  const closeSuccessNotification = () => {
    setSuccessUpdate(false);
  };
  const closeFailNotification = () => {
    setFailUpdate(false);
  };

  return (
    <div>
      <Snackbar
        message="Thank you for your feedback!"
        color="success"
        place="tr"
        open={successUpdate}
        close={true}
        closeNotification={closeSuccessNotification}
      />
      <Snackbar
        message="Feedback was not submitted...please try again later"
        color="danger"
        place="tr"
        open={failUpdate}
        close={true}
        closeNotification={closeFailNotification}
      />

      <GridContainer justify="center">
        <GridItem xs={12} sm={12} md={10}>
          <Card profile>
            <CardHeader color="success" icon>
              <GridContainer>
                <GridItem
                  xs={12}
                  sm={12}
                  md={3}
                  style={{ textAlign: "center" }}
                >
                  <CardIcon color="success">
                    <ThumbsUpDownIcon />
                  </CardIcon>
                </GridItem>
                <GridItem
                  xs={12}
                  sm={12}
                  md={6}
                  style={{ textAlign: "center" }}
                >
                  <h2 className={classes.cardTitle}>Rate Your Experience</h2>
                </GridItem>
                <GridItem xs={12} sm={12} md={3} style={{ textAlign: "right" }}>
                  <Button justIcon color="success" onClick={onClose}>
                    <i className={"fa fa-window-close"} />
                  </Button>
                </GridItem>
              </GridContainer>
            </CardHeader>

            <CardBody style={{ textAlign: "center" }}>
              <form>
                <h3 className={classes.cardTitle}>Interpreting Quality</h3>

                <StyledRating
                  name="interpretRating"
                  defaultValue={0}
                  precision={0.5}
                  size="large"
                  emptyIcon={<StarBorderIcon fontSize="large" />}
                  icon={<StarIcon fontSize="large" />}
                  value={interpretingRating}
                  onChange={handleInterpretingRatingChange}
                />

                <br />
                <br />

                <h3 className={classes.cardTitle}>Audio/Video Quality</h3>

                <StyledRating
                  name="avrating"
                  defaultValue={0}
                  precision={0.5}
                  size="large"
                  emptyIcon={<StarBorderIcon fontSize="large" />}
                  icon={<StarIcon fontSize="large" />}
                  value={avRating}
                  onChange={handleAvQualityRatingChange}
                />

                <GridContainer justify="center">
                  <GridItem
                    xs={12}
                    sm={12}
                    md={6}
                    style={{ textAlign: "center" }}
                  >
                    <CustomInput
                      id="avQualityComments"
                      inputProps={{
                        placeholder: "Please Leave Any Comments....",
                        multiline: true,
                        rows: 2,
                        onChange: (event) => handleCommentsChange(event),
                      }}
                      formControlProps={{
                        fullWidth: true,
                      }}
                    />

                    <br />
                    <br />

                    <Button color="success" onClick={handleRatingsSubmit}>
                      Submit
                    </Button>
                  </GridItem>
                </GridContainer>
              </form>
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
    </div>
  );
};
export default RequesterRating;
